var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpadesLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 11,
    fill: "#12101A",
    stroke: "#A046D3",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6199_60329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1431 24.5024C29.1431 21.8594 25.3248 20.4952 24.0361 18.0441L23.9883 18.0015L23.9645 18.0441C22.6758 20.4952 18.8574 21.8594 18.8574 24.5024C18.8574 26.719 22.1269 27.5716 23.7258 25.7173C23.7497 25.632 23.7258 26.3141 23.6065 26.6977C23.2247 27.8274 21.8405 29.4899 21.1723 30.0015C22.103 29.2981 25.8498 29.2981 26.7805 30.0015C26.1123 29.4899 24.7997 27.8913 24.3463 26.6977C24.2509 26.3567 24.2031 26.037 24.1793 25.696C25.7543 27.6995 29.1431 26.7617 29.1431 24.5024Z",
    fill: "#A046D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6199_60329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7143,
    height: 13.7143,
    fill: "white",
    transform: "translate(17.1431 17.1445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpadesLoader);
export default __webpack_public_path__ + "static/media/spades-loader.4778cb685eba4797e7aa49aaedcc7a74.svg";
export { ForwardRef as ReactComponent };